import type { ReactNode } from "react";
import { BODY_LINK_CLASS } from "@/lib/link-styles";

/** Markdown のリンク。アプリの画面を置き換えないよう、ブラウザの新しいタブで開く。 */
export function MarkdownLink({ href, children }: { href?: string; children?: ReactNode }) {
	return (
		<a href={href} className={BODY_LINK_CLASS} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	);
}
